blue.ready('bacon', 'body', body => {
  const elems = [...document.querySelectorAll('[data-bacon]')];
  const showForm = function(e) {
    e.preventDefault();

    let bacon = this.getAttribute('data-bacon');
    if(typeof createBaconWebClient === "function") {
      createBaconWebClient(bacon, 'https://web.baconpay.com');
    }
    else {
      console.log('Bacon Pay not loaded');
    }
  };

  if (Array.isArray(elems) && elems.length > 0) {
    // load baconpay external file
    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.src = `https://web.baconpay.com/embed.js`;
    script.onload = function () {
      elems.forEach(elem => elem.addEventListener('click', showForm));
    };
    document.querySelector('head').appendChild(script);
  }
});